import React from "react";

import Header from "../partials/Header";
import LeaderBoard from "./LeaderBoard";

function Home() {
  return (
    <div
      className="flex flex-col min-h-screen overflow-hidden"
      style={{ minWidth: "400px" }}
    >
      <Header />
      <main
        className="flex-grow min-h-screen"
        style={{ background: "#141924" }}
      >
        <LeaderBoard />
      </main>
    </div>
  );
}

export default Home;
